/**
 * Which build is actually on the phone.
 *
 * A service worker can serve a version that shipped days ago, so "I deployed a fix" and "the
 * fix is running" are separate claims. This is the only way to tell them apart from the couch.
 */

import { BUILD_ID, BUILT_AT, BUILT_AT_MS } from "../shared/build";

export { BUILD_ID, BUILT_AT, BUILT_AT_MS };

/** Enough to tell two builds apart at a glance on the footer; the panel carries the full sha. */
export const BUILD_TAG: string = BUILD_ID.replace(/\+$/, "").slice(-3) + (BUILD_ID.endsWith("+") ? "+" : "");

/** Local wall-clock time of the build, which is how it will be compared against a deploy. */
export function builtAtLabel(): string {
	if (BUILT_AT_MS == null) {
		return "unknown";
	}
	return new Date(BUILT_AT_MS).toLocaleString(undefined, {
		month: "short",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
	});
}
